import { render, staticRenderFns } from "./ReceiptHead.vue?vue&type=template&id=883640d2&scoped=true&"
import script from "./ReceiptHead.vue?vue&type=script&lang=ts&"
export * from "./ReceiptHead.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiptHead.vue?vue&type=style&index=0&id=883640d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883640d2",
  null
  
)

export default component.exports